import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=ed21efd2&"
import script from "./CourseCatalog.vue?vue&type=script&lang=js&"
export * from "./CourseCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports